import { useMutation } from "@tanstack/react-query";

import { useAxios, useApiResponseParser } from "../";

export default function useDocument() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData } = useApiResponseParser();

    function useGenerateContract() {
        return useMutation({
            mutationFn: (parameters: { ProjectId: string }) =>
                axiosPrivate.post(`/v1/document/generate-contract`, parameters).then(parseSuccessResponseData),
        });
    }

    function useTriggerContractSigning() {
        return useMutation({
            mutationFn: (parameters: { ProjectId: string; ToAddress: string }) =>
                axiosPrivate.post(`/v1/document/trigger-contract-signing`, parameters).then(parseSuccessResponseData),
        });
    }

    function useSupplyOrderCreate() {
        return useMutation({
            mutationFn: (parameters: any) =>
                axiosPrivate.post(`/v1/document/supply-order`, parameters).then(parseSuccessResponseData),
        });
    }

    function useHouseOwnerInvoiceCreate() {
        return useMutation({
            mutationFn: (parameters: any) =>
                axiosPrivate.post(`/v1/document/house-owner-invoice`, parameters).then(parseSuccessResponseData),
        });
    }

    function useInitialCreate() {
        return useMutation({
            mutationFn: (parameters: any) =>
                axiosPrivate.post(`/v1/document/create`, parameters).then(parseSuccessResponseData),
        });
    }

    function useList() {
        return useMutation({
            mutationFn: (params: any) =>
                axiosPrivate.get(`/v1/document/list`, { params }).then(parseSuccessResponseData),
        });
    }

    function useUpdateStatus() {
        return useMutation({
            mutationFn: (parameters: { DocumentId: string; Status: string }) =>
                axiosPrivate.post(`/v1/document/status/update`, parameters).then(parseSuccessResponseData),
        });
    }

    function useWorkOrderCreate() {
        return useMutation({
            mutationFn: (parameters: { ProjectId: string }) =>
                axiosPrivate.get(`/v1/document/work-order`, { params: parameters }).then(parseSuccessResponseData),
        });
    }

    return {
        useGenerateContract,
        useTriggerContractSigning,
        useList,
        useInitialCreate,
        useSupplyOrderCreate,
        useHouseOwnerInvoiceCreate,
        useUpdateStatus,
        useWorkOrderCreate,
    };
}
